import { render, staticRenderFns } from "./HeaderAccount.vue?vue&type=template&id=52201b1e&"
import script from "./HeaderAccount.vue?vue&type=script&lang=ts&"
export * from "./HeaderAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports